import movies from "./movies";
import users from "./users";

const search = { ...movies, ...users};

export default search;